import { useNavigate, useLocation } from "react-router-dom";


function Home() {
	return (
		<div >
			<div >
				<p>Ceci est la page Home</p>
			</div>
		</div>
	)
}

export default Home;